/*
 * 移动端公共方法标准化 - 客户端通信bridge
 */

import '@didi/soda-jsbridgev2'
import { compareVersion } from '@/common/utils/util'
import storage from 'didi-store'
import { util } from '@didi/soda-common'
const { env } = util
const semverGte = require('semver/functions/gte')

const DDbridge = {}

// 模拟默认bridge
DDbridge.install = function (Vue, options) {
  Vue.mixin({
    methods: {
      SodaBridge,
      SodaListener,
    },
  })
}

async function SodaBridge(methodName, param) {
  let statusBarInfo = {
    hasBar: true,
    barHeight: 0,
  }
  // 适配逻辑处理 可根据情况省略
  switch (methodName) {
    // 收口非标准param的bridge，新bridge无参数为{},旧版存在没有参数的情况，使用'badcase'标识
    case 'getGlobalParams':
    case 'removeTicket':
      return window.SodaBridgeV2(methodName, 'badcase')
    case 'getStatusBarHeight':
      // 客户端打开
      if (env.inNative) {
        const {
          data: { appVersion = '', platform = '' },
        } = await SodaBridge('getGlobalParams')
        let comVersionRes = -1
        // 存在通知栏的最高版本, 大于这些版本则没有端上的通知栏高度
        const existStausBarMaxVer = {
          ios: '1.2.4',
          android: '1.2.4',
        }
        comVersionRes = compareVersion(appVersion, existStausBarMaxVer[platform])
        // 端版本对比:没有通知栏
        if (String(comVersionRes) === '1') {
          console.log('对比结果比通知栏版本大且能获取到状态栏高度')
          window.SodaBridgeV2('getStatusBarHeight', 'badcase').then(res => {
            const barHeight = res.data.height / window.devicePixelRatio
            statusBarInfo = {
              hasBar: false,
              barHeight,
            }
            setStatusBarInfo(statusBarInfo, barHeight)
          })
        } else {
          // 有通知栏
          setStatusBarInfo(statusBarInfo, 0)
        }
      } else {
        // 浏览器中打开
        setStatusBarInfo(statusBarInfo, 0)
      }
      break
    case 'manager.cutPhoto':
      return window.SodaBridgeV2(methodName, param).catch(e => {
        if (e.errno === window.BRIDGE_STATUS_CODE.NOT_FOUND) {
          return window.SodaBridgeV2('sodaBD.cutPhoto', param)
        }
      })
    case 'toggleTitleBar':
      return new Promise(resolve => {
        window.Soda && window.Soda.toggleTitleBar && window.Soda.toggleTitleBar(param)
        resolve()
      })
    case 'exitApp':
      return new Promise(resolve => {
        window.Soda && window.Soda.exitApp && window.Soda.exitApp()
        resolve()
      })
    default:
      return window.SodaBridgeV2(methodName, param)
  }
}
function setStatusBarInfo(statusBarInfo, barHeight) {
  storage.set('StatusBarInfo', statusBarInfo) // 存储在storage中
  document.documentElement.style.setProperty('--barheight', `${barHeight}px`) // 设置全局css变量
}
export async function canOpenPageForNewWebview() {
  console.log('[log] canOpenPage111')
  const {
    data: { appVersion = '0.0.0' },
  } = await SodaBridge('getGlobalParams')
  const canOpenPage = Soda.openPage && semverGte(appVersion, '1.3.2')
  console.log('[log] canOpenPage', canOpenPage)
  return canOpenPage
}

function SodaListener(...args) {
  // methodName param cb OR methodName  cb
  return window.SodaListener(...args)
  /* 使用Soda监听桥
    SodaListener('customer.onCallStateChanged', (data) => {
      console.log('customer.onCallStateChanged', data)
    })
  }
  */
}

export default {
  SodaBridge,
  SodaListener,
  canOpenPageForNewWebview,
  ...DDbridge,
}
